import { MatSort } from '@angular/material/sort';
import { MatTable, MatTableDataSource, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import {IClient} from '../../../model/common.model';
import {ClientStatusService} from '../../status/client-status.service';
import { Component, OnInit, ViewChild, inject } from '@angular/core';

@Component({
    selector: 'app-viewpublicsite',
    standalone: true,
    templateUrl: './viewpublicsite.component.html',
    styleUrls: ['./viewpublicsite.component.scss'],
    imports: [
      MatTable,
      MatColumnDef,
      MatHeaderCellDef,
      MatHeaderCell,
      MatCellDef,
      MatCell,
      MatHeaderRowDef,
      MatHeaderRow,
      MatRowDef,
      MatRow,
      MatSort
    ]
})
export class ViewpublicsiteComponent implements OnInit {
  private clientStatusSvc = inject(ClientStatusService);


  clientList: IClient[] = [];
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  columnDef = ['code'];

  @ViewChild('sort', {static: true}) sort: MatSort;

  constructor() { }

  ngOnInit() {
    this.getClients();
  }

  getClients = () => {
    this.clientList = [];    
    this.clientStatusSvc.doGet('admin/client').subscribe( (data: IClient[]) => {
       this.clientList = this.clientStatusSvc.sortArray(data || [], 'code', 'asc');               
       this.dataSource = new MatTableDataSource<any>( this.clientList);
       this.dataSource.sort = this.sort;
    }, (error: any)=> {
      this.clientStatusSvc.showWarning(`Error while getting existing clients.`, error.message? error.message: null);      
    });
  }

  openClientPage(clientCode: string) {
    const url = `${window.location.origin}/${clientCode}`;
    window.open(url, '_blank');
  }

}
